import { EmptyListContent } from "@jugl-web/ui-components";
import { useTranslations } from "@jugl-web/utils";
import React from "react";
import { Lottie } from "@jugl-web/utils/utils/Lottie";
import { useChatBot } from "@jugl-web/domain-resources/chat-bot";
import twilioAnimation from "./assets/twilio-animation.json";

export const TwilioAccountScreen: React.FC = () => {
  const { t } = useTranslations();
  const { isInitialized: isChatBotInitialized, show: showChatBot } =
    useChatBot();

  return (
    <EmptyListContent
      className="w-[500px]"
      type="custom"
      customImg={
        <Lottie
          options={{ animationData: twilioAnimation }}
          width={356}
          height={200}
        />
      }
      customTitle={
        <span className="font-secondary text-2xl font-medium text-black">
          {t({
            id: "client-support-page.unlock-unlimited-sms-marketing",
            defaultMessage: "Unlock unlimited SMS Marketing",
          })}
        </span>
      }
      customSubtitle={
        <div className="flex flex-col">
          <span className="font-secondary text-[#828282]">
            {t(
              {
                id: "client-support-page.sms-marketing-description",
                defaultMessage:
                  "Quick and easy way for business communications.{br}Enable Text (SMS) Chat to <highlightedText>power up your efficiency</highlightedText>",
              },
              {
                br: <br />,
                highlightedText: (text: (string | JSX.Element)[]) => (
                  <span className="text-primary-800 font-medium italic">
                    {text}
                  </span>
                ),
              }
            )}{" "}
            ⚡
          </span>
          <div className="bg-grey-200 my-6 h-px w-full" />
          <span className="font-secondary text-sm italic text-[#828282]">
            *
            {t(
              {
                id: "client-support-page.sms-marketing-connection-support",
                defaultMessage:
                  "To connect Account, reach out to our Support Team, or send us an email at <email>support@jugl.com</email>",
              },
              {
                email: (text: (string | JSX.Element)[]) => (
                  <a
                    className="text-primary font-medium underline"
                    href="mailto:support@jugl.com"
                  >
                    {text}
                  </a>
                ),
              }
            )}{" "}
            🙌
          </span>
        </div>
      }
      customButton={{
        text: t({
          id: "client-support-page.contact-support",
          defaultMessage: "Contact Support",
        }),
        className: "w-[200px]",
        onClick: () =>
          isChatBotInitialized
            ? showChatBot()
            : window.open("https://help.jugl.com/en/", "_blank"),
      }}
    />
  );
};
